import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "center-y" }

import { IonCheckbox } from "@ionic/vue";
import { ref, computed, onMounted } from "vue";
import { useField } from "vee-validate";

import { CheckboxSimpleProps } from "@/types/props";
import { CheckboxSimpleEmits } from "@/types/emits";


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckboxSimple',
  props: {
    modelValue: { type: Boolean },
    value: { type: Boolean },
    labelClass: {},
    name: {}
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const checkbox = ref()

const checkboxValue = computed<boolean>({
    get: () => {
        if (!props.modelValue) return props.value ?? false
        return props.modelValue
    },
    set: (value) => {
        emit('update:modelValue', value)
        emit('change', value)
        handleChange(value);
    }
})

const { handleChange } = useField(props.name ?? '', undefined, {
    // Will make the checkbox set its value to true/false if it was checked or not
    type: 'checkbox',
    checkedValue: true,
    uncheckedValue: false,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonCheckbox), {
      class: "grey4-grey4-background custom-light-checkbox",
      ref_key: "checkbox",
      ref: checkbox,
      modelValue: checkboxValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkboxValue).value = $event)),
      name: __props.name
    }, null, 8, ["modelValue", "name"]),
    _createElementVNode("span", {
      class: _normalizeClass(["ml-1 cursor-pointer disable-text-select fs-smaller fw-b", __props.labelClass]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (checkbox.value.$el.click()))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})